PT.Utils.trackError = (error) ->
  trackJs.track(error) if trackJs?
  console.log(error) if window.console?